/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {JobWorkflow, JobWorkflowFromJSON, JobWorkflowToJSON,} from './JobWorkflow';

/**
 *
 * @export
 * @interface JobWorkflowApiResult
 */
export interface JobWorkflowApiResult {
    /**
     *
     * @type {boolean}
     * @memberof JobWorkflowApiResult
     */
    success?: boolean;
    /**
     *
     * @type {JobWorkflow}
     * @memberof JobWorkflowApiResult
     */
    content?: JobWorkflow;
    /**
     *
     * @type {string}
     * @memberof JobWorkflowApiResult
     */
    message?: string | null;
}

export function JobWorkflowApiResultFromJSON(json: any): JobWorkflowApiResult {
    return JobWorkflowApiResultFromJSONTyped(json, false);
}

export function JobWorkflowApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobWorkflowApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : JobWorkflowFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JobWorkflowApiResultToJSON(value?: JobWorkflowApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': JobWorkflowToJSON(value.content),
        'message': value.message,
    };
}

